export default __webpack_public_path__ + "static/media/18.5cb55206.svg";